import './App.css';
import { Box, CssBaseline, Stack, Divider, ThemeProvider } from '@mui/material';
import { alpha } from '@mui/material/styles';
import SignIn from './pages/admin/Authentification/SignIn';
import theme from "./components/theme";
import { AuthProvider, useAuth } from './context/AuthContext';
import { Route, Routes } from 'react-router';
import PrivateRoute from './routes/PrivateRoute';
import NotFound from './pages/admin/NotFound';
import Dashboard from './Dashboard';
import OAuthSuccess from './pages/admin/OAuthSuccess';
import ClientLayout from './layouts/ClientLayout';
import RootRedirect from './pages/RootRedirect';

function App() {


  return (
    <ThemeProvider theme={theme}>
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        <Route path="/login" element={<SignIn />} />
        <Route path="/oauth-success" element={<OAuthSuccess />} />
        <Route
          path="/dashboard/*"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <Dashboard />
            </PrivateRoute>
          }
        >

        </Route>
         <Route
          path="/app/*"
          element={
            <PrivateRoute allowedRoles={["client"]}>
              <ClientLayout />
            </PrivateRoute>
          }
        >

        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
